import React from 'react';

import { Box, Chip, Stack, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { formatNumber, getTriangleIconSx } from './utils';

interface Props {
  tierTotals: { HIGH: number; MEDIUM: number; LOW: number };
}

export default function TierTotalsLegend({ tierTotals }: Props) {
  const theme = useTheme();
  const triangleIconSx = getTriangleIconSx(theme);

  return (
    <Stack direction="row" spacing={2} mb={2}>
      <Chip
        icon={
          <Box
            sx={{
              width: theme.spacing(1.5),
              height: theme.spacing(1.5),
              borderRadius: '50%',
              bgcolor: 'success.main',
            }}
          />
        }
        label={`HIGH: ${formatNumber(tierTotals.HIGH)} properties`}
        variant="outlined"
        sx={{ borderColor: 'success.main', bgcolor: alpha(theme.palette.success.main, 0.12) }}
      />
      <Chip
        icon={
          <Box
            sx={{
              ...triangleIconSx,
              borderBottom: `${theme.spacing(1.5)} solid ${theme.palette.warning.main}`,
            }}
          />
        }
        label={`MEDIUM: ${formatNumber(tierTotals.MEDIUM)} properties`}
        variant="outlined"
        sx={{ borderColor: 'warning.main', bgcolor: alpha(theme.palette.warning.main, 0.12) }}
      />
      <Chip
        icon={
          <Box
            sx={{
              ...triangleIconSx,
              borderBottom: `${theme.spacing(1.5)} solid ${theme.palette.error.main}`,
            }}
          />
        }
        label={`LOW: ${formatNumber(tierTotals.LOW)} properties`}
        variant="outlined"
        sx={{ borderColor: 'error.main', bgcolor: alpha(theme.palette.error.main, 0.12) }}
      />
    </Stack>
  );
}
